import * as types from './actionTypes';
import variableProductDetailsApi from '../api/variableProductDetailsApi';
import Swal from 'sweetalert2'

export function doVariableProductDetails(data) {

    return {
        type: types.DO_VARIABLEPRODUCTDETAILS,
        data
    };
}

export function doVariableProductDetailsRes(user) {
    return {
        type: types.DO_VARIABLEPRODUCTDETAILS_RES,
        user
    };
}

export function productVariable(data) {
    return function (dispatch) {
        variableProductDetailsApi.doVariableProductDetails(data).then(res => {
            dispatch(doVariableProductDetailsRes(res));
            if (res.result === false && res.data === null) {

                Swal.fire({
                    title: 'Product is not available',
                    // icon: 'error',
                    //confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    timer: 1000
                })

            }

        }).catch(error => {
            return error
        });
    };
}